import { useOrganization } from "../../context/OrganizationContext";
import { OrganizationFeaturesProvider } from "../../context/OrganizationFeaturesContext";
import UnifiedSidebar from "../Sidebar/UnifiedSidebar";
import OrganizationHeader from "./OrganizationHeader";
import { isOrganizationFirstSetupActive } from "../../utility/organizationFirstSetup";

const OrganizationLayout = ({ children }) => {
  const { currentOrganization } = useOrganization();

  const content =
    !currentOrganization || isOrganizationFirstSetupActive() ? (
      <>{children}</>
    ) : (
      <div className="min-h-screen bg-brand-cream overflow-x-clip">
        <OrganizationHeader />
        <div className="flex">
          <UnifiedSidebar context="organization" />
          <main className="flex-1 min-w-0 p-4 sm:p-6 lg:pb-6 max-lg:pb-[var(--tournament-mobile-clearance,calc(3.5rem+0.75rem+env(safe-area-inset-bottom,0px)))]">{children}</main>
        </div>
      </div>
    );

  return (
    <OrganizationFeaturesProvider>{content}</OrganizationFeaturesProvider>
  );
};

export default OrganizationLayout;
